import { NgModule } from '@angular/core';
import { fullHeightDirective } from './fullHeight';

@NgModule({
    declarations: [
      fullHeightDirective
    ],
    exports: [
        fullHeightDirective
    ]
})
export class fullHeightModule { }